import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CognitoUtil } from 'src/app/shared/utils/cognito.service';
import { StateManagementService } from '../shared/services/state-management.service';
import { LoaderService } from '../shared/utils/loader.service';
import { LocalizationService } from '../shared/services/localization.service';

@Component({
  selector: 'app-site-management',
  templateUrl: './site-management.component.html',
  styleUrls: ['./site-management.component.scss'],
})
export class SiteManagementComponent implements OnInit {
  constructor(
    private route: Router,
    public cognitoUtil: CognitoUtil,
    private stateManagementService: StateManagementService,
    private loaderService: LoaderService,
    private localizationService: LocalizationService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.loaderService.hide();
    this.stateManagementService.updateShowHeader(true);
  }
}
